import Login from "./components/Login";
import LoginWithSso from "./components/LoginWithSso";
import Forget from "./components/Forget";

export const routes = [
  {
    path: "/login",
    exact: true,
    component: Login,
    name: "Login"
  },
  {
    path: "/forget",
    exact: true,
    component: Forget,
    name: "Forgot"
  },
  {
    path: "/token-login/:token",
    exact: true,
    component: LoginWithSso,
    name: "LoginWithSso"
  },
];
